export const EVALUATION_SESSION_TYPES = [
  { value: 'EXAMEN_DOMICILE', label: 'Examen à domicile' },
  { value: 'EXAMEN_SUR_PLACE', label: 'Examen sur place (live)' },
  { value: 'TP_DOMICILE', label: 'TP à domicile' },
  { value: 'TP_SUR_PLACE', label: 'TP sur place (live)' },
  { value: 'SOUTENANCE', label: 'Soutenance' },
  { value: 'PROJET', label: 'Projet' },
  { value: 'QUESTIONNAIRE', label: 'Série de questionnaires' },
  { value: 'MOCK', label: 'Examen blanc (mock)' },
  { value: 'INTERROGATION', label: 'Interrogation' },
  { value: 'DEVOIR', label: 'Devoir' },
] as const;

export type EvaluationSessionType = (typeof EVALUATION_SESSION_TYPES)[number]['value'];

const QUESTION_TYPES = new Set<EvaluationSessionType>([
  'QUESTIONNAIRE',
  'MOCK',
  'INTERROGATION',
  'EXAMEN_DOMICILE',
  'EXAMEN_SUR_PLACE',
  'DEVOIR',
]);

const FILE_TYPES = new Set<EvaluationSessionType>(['TP_DOMICILE', 'TP_SUR_PLACE', 'PROJET', 'SOUTENANCE']);

const LIVE_TYPES = new Set<EvaluationSessionType>(['EXAMEN_SUR_PLACE', 'TP_SUR_PLACE']);

export function evaluationRequiresQuestions(type: EvaluationSessionType): boolean {
  return QUESTION_TYPES.has(type);
}

export function evaluationAllowsFile(type: EvaluationSessionType): boolean {
  return FILE_TYPES.has(type) || type === 'DEVOIR';
}

export function evaluationIsLiveType(type: EvaluationSessionType): boolean {
  return LIVE_TYPES.has(type);
}

export const EVALUATION_SESSION_STATUT_LABELS: Record<string, string> = {
  BROUILLON: 'Brouillon',
  PUBLIEE: 'Publiée',
  OUVERTE: 'Ouverte',
  TERMINEE: 'Terminée',
  ANNULEE: 'Annulée',
};

export const EVALUATION_CORRECTION_MODES = [
  {
    value: 'AUTOMATIQUE',
    label: 'Correction automatique',
    description:
      'Vous définissez les bonnes réponses : la note est calculée à la soumission de chaque apprenant.',
  },
  {
    value: 'MANUELLE',
    label: 'Correction manuelle',
    description: 'Vous corrigez vous-même chaque copie et attribuez la note sur le relevé.',
  },
] as const;

export type EvaluationCorrectionMode = (typeof EVALUATION_CORRECTION_MODES)[number]['value'];

export const EVALUATION_CORRECTION_MODE_LABELS: Record<string, string> = Object.fromEntries(
  EVALUATION_CORRECTION_MODES.map((m) => [m.value, m.label]),
);

export const TENTATIVE_STATUT_LABELS: Record<string, string> = {
  EN_ATTENTE: 'En attente',
  EN_COURS: 'En cours',
  SOUMIS: 'Soumis',
  EXPIRE: 'Expiré',
  ABSENT: 'Absent',
};
